<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->

<form mat-dialog-content [formGroup]="crewSizeForm" class="crew-size-form-container">
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>{{ data.title }}</mat-label>
		<input
			matInput
			class="crew-form-input"
			type="number"
			[min]="minSize"
			[max]="maxSize"
			formControlName="crewSize"
		/>
	</mat-form-field>
</form>

<button-footer [saveOrCloseButtonText]="data.yesButtonText" (buttonSaveOrClose)="onSave()">
	<button type="button" leftButton (click)="onButtonCloseSelect()" mat-stroked-button color="primary">
		{{ data.noButtonText }}
	</button>
</button-footer>
